<template>
    <BaseWidget v-bind="$attrs" :widget="meta" :loading="loading">
        <div class="dw-subs-body" :class="{ 'dw-subs-body--empty': !items.length }">
            <div v-if="!items.length" class="dw-subs-empty">
                <div class="dw-subs-empty-icon"><i class="bi bi-shield-check"></i></div>
                <div class="dw-subs-empty-text">{{ $t('common.dashboard.widgetEmpty.subscriptionsTitle') }}</div>
                <div class="dw-subs-empty-sub">{{ $t('common.dashboard.widgetEmpty.subscriptionsSub') }}</div>
            </div>
            <div v-else class="dw-subs-list">
                <div v-for="sub in items" :key="sub.id" class="dw-subs-card" :class="'dw-subs-card--' + sub.status.class" :style="{ '--subs-accent': statusMap[sub.status.class]?.color }">
                    <div class="dw-subs-card-left">
                        <div class="dw-subs-icon-wrap" :style="{ color: statusMap[sub.status.class]?.color, background: statusMap[sub.status.class]?.bg }">
                            <i :class="['bi', sub.status.class === 'active' ? 'bi-check-circle-fill' : sub.status.class === 'expired' ? 'bi-x-circle-fill' : 'bi-pause-circle-fill']"></i>
                        </div>
                    </div>
                    <div class="dw-subs-card-mid">
                        <div class="dw-subs-card-name">{{ sub.product_name }}</div>
                        <div class="dw-subs-card-meta">
                            <span v-if="!sub.expires_at" class="dw-subs-days" :style="{ color: statusMap[sub.status.class]?.color }">{{ $t('common.dashboard.widgetLabels.subsUnlimited') }}</span>
                            <span v-else-if="sub.remaining_days > 0" class="dw-subs-days" :style="{ color: statusMap[sub.status.class]?.color }">{{ $t('common.dashboard.widgetLabels.subsRemainingDays', { days: sub.remaining_days }) }}</span>
                            <span v-else class="dw-subs-days">{{ formatDate(sub.expires_at) }}</span>
                        </div>
                        <div v-if="sub.expires_at && (sub.status.class === 'active' || sub.status.class === 'suspended')" class="dw-subs-progress">
                            <div class="dw-subs-progress-fill" :style="{ width: progress(sub) + '%' }"></div>
                        </div>
                    </div>
                    <div class="dw-subs-card-right">
                        <span class="dw-subs-chip" :style="{ color: statusMap[sub.status.class]?.color, background: statusMap[sub.status.class]?.bg }">
                            {{ sub.status.label }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '../BaseWidget.vue';
import widgetMixin from '../widgetMixin';
import { formatSubDate, subscriptionProgress, STATUS_MAP } from './_subscriptionUtils';

export const meta = {
    id: 'subscriptions',
    titleKey: 'common.dashboard.widgetTitles.subscriptions',
    icon: 'bi-shield-check',
    accent: 'var(--bs-info)',
    accentBg: 'rgba(var(--bs-info-rgb, 114, 57, 234), 0.12)',
    glassRgb: '114, 57, 234',
    defaultCol: 1,
    defaultRow: 1,
    source: { type: 'statistics', key: 'subscriptions' },
};

export default {
    name: 'SubscriptionsWidget',
    components: { BaseWidget },
    mixins: [widgetMixin],
    data() {
        return {
            meta,
            statusMap: STATUS_MAP,
        };
    },
    computed: {
        items() {
            return Array.isArray(this.apiData) ? this.apiData : [];
        },
    },
    methods: {
        formatDate: formatSubDate,
        progress: subscriptionProgress,
    },
};
</script>

<style>
.dw-subs-body--empty { align-items: center; justify-content: center; }
.dw-subs-empty {
    flex: 1;
    display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    gap: 8px; text-align: center;
    padding: 8px 12px;
}
.dw-subs-empty-icon {
    width: 56px; height: 56px;
    border-radius: 16px;
    display: flex; align-items: center; justify-content: center;
    background: rgba(var(--bs-info-rgb, 114, 57, 234), 0.10);
    color: var(--bs-info);
    margin-bottom: 4px;
}
.dw-subs-empty-icon .bi { font-size: 26px; }
.dw-subs-empty-text {
    font-size: 13px; font-weight: 600;
    color: var(--bs-body-color);
}
.dw-subs-empty-sub {
    font-size: 11px; color: var(--bs-gray-500);
    line-height: 1.4; max-width: 220px;
}
</style>
